module.exports = __webpack_public_path__ + "49d985e02337940d9f5a041134a9bf33.pdf";